/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Installment_BalanceInputs */

const en_case_payment_validation_installment_balance = /** @type {(inputs: Case_Payment_Validation_Installment_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installment plans must leave an amount to be paid in installments.`)
};

const pt_br2_case_payment_validation_installment_balance = /** @type {(inputs: Case_Payment_Validation_Installment_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O parcelamento deve deixar um valor para pagamento em parcelas.`)
};

/**
* | output |
* | --- |
* | "Installment plans must leave an amount to be paid in installments." |
*
* @param {Case_Payment_Validation_Installment_BalanceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_installment_balance = /** @type {((inputs?: Case_Payment_Validation_Installment_BalanceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Installment_BalanceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_installment_balance(inputs)
	return pt_br2_case_payment_validation_installment_balance(inputs)
});